<template>
  <v-card>
    <EventTabReportFilter class="mb-4 px-4" @onFilterChanged="onFilterChanged" />
    <!-- event export excel -->
    <div class="d-flex justify-end mb-4 px-4">
      <EventTabReportExportExcel />
    </div>
    <EventTabReportTable />
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import EventTabReportExportExcel from './EventTabReportExportExcel.vue'
import EventTabReportFilter from './EventTabReportFilter.vue'
import EventTabReportTable from './EventTabReportTable.vue'

export default {
  components: { EventTabReportTable, EventTabReportFilter, EventTabReportExportExcel },
  methods: {
    ...mapActions({
      search: 'eventSlotStudents/search'
    }),
    async onFilterChanged(data = {}) {
      await this.search({...data, event: this.$route.params.id})
    }
  },
  async mounted() {
    await this.search({event: this.$route.params.id})
  }
}
</script>
